const wrapperElementsNodes = document.querySelectorAll('.js-release-search-wrapper');
const $wrapperElements = Array.prototype.slice.call(wrapperElementsNodes, 0);

const SEARCH_URL = '/main/action.php?run=html&page=searchkey&search_word=';

const useReleaseSearchInput = ($wrapper) => {
  const $elements = {
    input: $wrapper.querySelector('.js-release-search-input'),
    submitButton: $wrapper.querySelector('.js-release-search-submit-button'),
    deleteButton: $wrapper.querySelector('.js-release-search-delete-button')
  };

  function releaseSearch () {
    if ($elements.input.value !== '') {
      const url = SEARCH_URL + encodeURIComponent($elements.input.value);
      window.location.href = url;
    }
  }
  function addEventToInput () {
    $elements.input.addEventListener('keydown', e => {
      if (e.keyCode === 13) {
        releaseSearch();
        e.preventDefault();
      }
    });
  }

  function addEventToSubmitButton () {
    $elements.submitButton.addEventListener('click', e => {
      releaseSearch();
      e.preventDefault();
    });
  }

  function addEventToDeleteButton () {
    $elements.deleteButton.addEventListener('click', e => {
      $elements.input.value = '';
      e.preventDefault();
    });
  }

  function init () {
    if ($elements.input !== null) {
      addEventToInput();
    }
    if ($elements.submitButton !== null) {
      addEventToSubmitButton();
    }
    if ($elements.deleteButton !== null) {
      addEventToDeleteButton();
    }
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($wrapperElements !== null) {
    $wrapperElements.forEach(el => {
      useReleaseSearchInput(el);
    });
  }
});
